import React, { useCallback, useMemo } from 'react';
import { BaseFilter, BaseFilterState, FilterConfig } from '../../../shared/ui';

// Интерфейс для состояния фильтров платежей V2
export interface PaymentsV2FilterState {
  startDate?: Date;
  endDate?: Date;
  userId?: number;
}

interface PaymentsV2FilterProps {
  filters: PaymentsV2FilterState;
  onFiltersChange: (filters: PaymentsV2FilterState) => void;
  siteId: number; // ID объекта для загрузки участников
  className?: string;
  hasFinanceViewPermission?: boolean; // Есть ли право на просмотр финансов (если нет - скрываем фильтр по сотруднику)
}

const PaymentsV2Filter: React.FC<PaymentsV2FilterProps> = ({ 
  filters, 
  onFiltersChange, 
  siteId,
  className = '',
  hasFinanceViewPermission = true
}) => {
  // Конфигурация фильтров - период и сотрудник
  // Фильтр по сотруднику отключаем, если нет прав на просмотр финансов (доступны только личные платежи)
  const filterConfig: FilterConfig[] = useMemo(() => [
    { type: 'period', label: 'Период', enabled: true },
    { type: 'user', label: 'Сотрудник', enabled: hasFinanceViewPermission }
  ], [hasFinanceViewPermission]);

  // Преобразуем локальное состояние в базовое
  const baseFilters: BaseFilterState = useMemo(() => ({
    startDate: filters.startDate,
    endDate: filters.endDate,
    userId: filters.userId
  }), [filters.startDate, filters.endDate, filters.userId]);

  // Обработчик изменений фильтров
  const handleBaseFiltersChange = useCallback((newFilters: BaseFilterState) => {
    // Преобразуем базовые фильтры обратно в локальное состояние
    const updatedFilters: PaymentsV2FilterState = {
      startDate: newFilters.startDate,
      endDate: newFilters.endDate,
      userId: newFilters.userId
    };
    
    onFiltersChange(updatedFilters);
  }, [onFiltersChange]);

  return (
    <BaseFilter
      filters={baseFilters}
      onFiltersChange={handleBaseFiltersChange}
      filterConfig={filterConfig}
      className={className}
      siteId={siteId}
    />
  );
};

export default PaymentsV2Filter;

